// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i6-j";
export var fulfillmentFormRail = "_i6-i";
export var headerTitleRow = "_i6-l";
export var orderDetailsWrapper = "_i6-g";
export var orderLinkTrigger = "_i6-2";
export var paymentInformationGrid = "_i6-q";
export var paymentSummaryColumn = "_i6-r";
export var phoneShipmentPickerButton = "_i6-e";
export var phoneShipmentPickerButtonContent = "_i6-f";
export var phoneShipmentPickerButtonWrapper = "_i6-d";
export var phoneShipmentPickerTrigger = "_i6-c";
export var shipmentContainer = "_i6-k";
export var shipmentDetailsMainPane = "_i6-h";
export var shipmentNavigationCard = "_i6-a";
export var shipmentNavigationEdgeTrigger = "_i6-6";
export var shipmentNavigationRail = "_i6-3";
export var shipmentNavigationRailEnter = "_i6-5";
export var shipmentNavigationRailHeader = "_i6-9";
export var shipmentNavigationRailOverlay = "_i6-4";
export var shipmentNavigationScrim = "_i6-7";
export var shipmentSummaryFact = "_i6-n";
export var shipmentSummaryGrid = "_i6-m";
export var shipmentSummaryMetadataRow = "_i6-o";
export var shipmentSummaryTags = "_i6-p";
export var shipmentWorkspace = "_i6-0";
export var shipmentWorkspaceBodyTablet = "_i6-8";
export var shipmentWorkspaceContent = "_i6-b";
export var shipmentWorkspaceHeader = "_i6-1";